import ApplicationController from './application_controller';

// Therapist fill: decides what happens to the guardian's signature when a staff member saves an
// intake document they filled out on the family's behalf.
//
// Two modes, chosen at save time:
//   defer      the family still signs in the patient portal (default)
//   in_person  a guardian is present and signs on the therapist's device
//
// The signature pad stays in the DOM in both modes. signature_pad is constructed once against the
// canvas at page load (app/javascript/packs/application.js) and cannot be built later, so this
// controller only shows and hides it. The chosen mode is written into a hidden field that both the
// submit guard (app/javascript/signature-pad/main.js) and IntakeDocumentsController#update read.
//
// Apply via `data-controller="intake-signature-mode"`.
export default class extends ApplicationController {
  static targets = ['mode', 'pad', 'option'];

  connect() {
    this.#sync();
  }

  choose() {
    this.#sync();
  }

  #sync() {
    if (!this.hasModeTarget) return;

    const selected = this.optionTargets.find((option) => option.checked);
    const mode = selected ? selected.value : 'defer';

    this.modeTarget.value = mode;
    if (!this.hasPadTarget) return;

    const wasHidden = this.padTarget.hidden;
    this.padTarget.hidden = mode !== 'in_person';

    // Re-measure the canvas the first time it becomes visible.
    //
    // signature_pad is constructed once at page load (app/javascript/packs/application.js), and
    // signature-pad/main.js sizes the canvas backing store from offsetWidth/offsetHeight straight
    // away. While this wrapper is hidden those are both 0, so the canvas ends up 0x0 and every
    // stroke lands outside it — the pad looks fine and does nothing. main.js assigns resizeCanvas
    // to window.onresize, so a resize event re-measures it. rAF so the browser has laid the
    // element out before we measure.
    if (wasHidden && !this.padTarget.hidden) {
      requestAnimationFrame(() => window.dispatchEvent(new Event('resize')));
    }
  }
}
